<template>
  <div class="subtradezone-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'subtradezones' , params: { id: this.item.tradezone_id }}" class="float-left mr-1 main-link">
                    {{$t('store.subtradezone')}}
                  </router-link>
                  / {{$t('store.subtradezone_customize_edit')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="pb-15">
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer" class="header">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('store.subtradezone_customize') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                 <!-- Subtradezone Name-->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('store.subtradezone_name')}}</legend>
                    <div class="col-sm-4">
                      <b-form-input class="form-control" v-model="item.subtradezone_name" :disabled="true" type="text"></b-form-input>
                    </div>
                  </div>
                  <!-- Subtradezone Name-->
                  <!-- Delivery fee-->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('store.subtradezone_delivery_fee')}}</legend>
                    <div class="col-sm-4">
                      <b-form-input class="form-control" v-model="item.delivery_fee" type="number"></b-form-input>
                    </div>
                  </div>
                  <!-- Delivery fee-->

                   <!-- Delivery time-->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('store.subtradezone_delivery_time')}}</legend>
                    <div class="col-sm-4">
                      <b-form-input class="form-control" v-model="item.delivery_time" type="number"></b-form-input>
                    </div>
                  </div>
                  <!-- Delivery time-->
                    <!-- Business hours -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('store.subtradezone_opening')}}</legend>
                    <div class="col-sm-1">
                        <masked-input
                            type="text" name="date" v-model="item.business_hours.opening" class="form-control"
                            :mask="[/\d/, /\d/, ':', /\d/, /\d/]" :guide="true" placeholderChar="_" :showMask="true"
                            :keepCharPositions="true">
                        </masked-input>
                    </div>
                  </div>
                  <div class="form-group row">
                      <legend class="col-sm-2 col-form-label">{{$t('store.subtradezone_closing')}}</legend>
                      <div class="col-sm-1">
                        <masked-input
                            type="text" name="date" v-model="item.business_hours.closing" class="form-control"
                            :mask="[/\d/, /\d/, ':', /\d/, /\d/]" :guide="true" placeholderChar="_" :showMask="true"
                            :keepCharPositions="true">
                        </masked-input>
                        </div>
                  </div>
                  <!-- Business hours -->
                </b-col>
              </b-form>
            </b-collapse>

            <div slot="footer">
              <router-link :to="{ name: 'subtradezones',params: { id: this.item.tradezone_id }, query: {rollback: 1}}"
                           class="btn btn-back border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i>
                {{$t('common.back')}}
              </router-link>
              <div class="btn-save">
                <b-button :disabled="checkSubmit()" variant="success"  v-on:click="saveSubTradezoneCustomize()">&nbsp; {{ $route.params.id
                  ? $t('common.update') : $t('common.save')}}
                </b-button>
              </div>
            </div>
          </b-card>
          <div class="clear-both"></div>
        </b-col>

      </b-row>
    </div>
  </div>
</template>


<script>
  import {validationMixin} from 'vuelidate'
  import {required,requiredIf} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-text-mask'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import moment from 'moment'
  import axios from 'axios'

  let vm = null

  export default {
    name: 'FormSubTradezone',
    props: {
      id: {
        type: String,
        required: false
      }
    },
    components: {
      cSwitch,
      vSelect,
      MaskedInput,
      CustomizeField,
    },
    data: function () {
      return {
        item: {
            tradezone_id: 0,
            name: '',
            business_hours: {
                opening: '',
                closing: ''
            },
            delivery_fee: 0,
            delivery_time: 0,
            tradezone_id: 0,
        },
        basicInformationStatus: true,
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
        // delivery_fee: {
        //     numeric
        // },
        // delivery_time: {
        //    numeric
        // },
        
    },
    computed: {},
    methods: {
      checkSubmit: function () {
        let validateName = false
        // let form = vm.$v.item.$invalid
        // return form || validateName
      },
      saveSubTradezoneCustomize: function(){
        let data = JSON.parse(JSON.stringify(vm.item))
        let formData = new FormData()
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        const customizeSubTradezone = {
            business_hours: data.business_hours,
            delivery_fee: parseFloat(data.delivery_fee),
            delivery_time: parseInt(data.delivery_time),
        }
        const subTradezoneId = data.id;
        formData.append('id', subTradezoneId);
        formData.append('customize', JSON.stringify(customizeSubTradezone));
        vm.axios.outlet.updateSubTradezone(formData, config, function (response) {
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              vm.$router.push({name: 'subtradezones', params: { id: data.tradezone_id }})
            }, function () {
        })

      },
      /**
       * get list subtradezone detail
       */
      getSubTradezoneDetail () {
        let subTradezoneId = this.$route.params.id;
        vm.axios.outlet.getSubTradezoneDetail(subTradezoneId, function (response) {
          let item = response.data.data.item
          vm.item = item
        })
      },
       /**
       * update status of customise session
       */
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
    },
    created: function () {
      vm = this
    },
    updated: function () {
    },
    mounted: function () {
      vm.getSubTradezoneDetail()
    }
  }

</script>

<style scoped>
.subtradezone-form .btn-success {
    float: right;
 }
.card-footer {
  margin-left: 0px!important;
}
</style>
<style>
.btn-back {
    background-color: #0091ff;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/tradezone/FormSubTradezone.vue